import MaskedInput from 'react-text-mask';
import { TextField } from '@qrios/frontend-library';
import { forwardRef, ChangeEvent, ReactNode } from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

type ChangeHandler = (e: ChangeEvent<{ name: string; value: string }>) => void;

interface Props {
  value: string | number;
  handleChange: ChangeHandler;
  handleBlur: ChangeHandler;
  touched?: boolean;
  error?: string;
  label: string;
  name: string;
  startAdornment?: ReactNode;
  placeholder?: string;
}
const amountMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2, // how many digits allowed after the decimal
  // integerLimit: 20, // limit length of integer numbers, when commented  - no limits
  allowNegative: false,
  allowLeadingZeroes: false
};
const amountMaskInput = createNumberMask(amountMaskOptions);

const AmountMask = forwardRef((props, ref) => (
  <MaskedInput
    {...props}
    inputMode="numeric"
    ref={inputRef => {
      if (inputRef) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ref(inputRef.inputElement);
      }
    }}
    mask={amountMaskInput}
    showMask={false}
  />
));

const AmountMaskedInput = (props: Props) => <TextField data-testid="input-amount" customMask={AmountMask} {...props} />;

export default AmountMaskedInput;
